import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import Wrapper from '../Wrapper';

dayjs.extend(LocalizedFormat);

const DateTime = ({ format, customFormat, modifier }) => {
  const dateFormat = customFormat || format;

  if (!dateFormat) return null;

  const formatedDate = dayjs().format(dateFormat);

  return (
    <Wrapper className="date" modifiers={modifier}>
      {formatedDate}
    </Wrapper>
  );
};

DateTime.propTypes = {
  format: PropTypes.string.isRequired,
  customFormat: PropTypes.string,
  modifier: PropTypes.string
};

DateTime.defaultProps = {
  modifier: null,
  customFormat: ''
};

export default DateTime;
